import { render, staticRenderFns } from "./createBulkPromotion.vue?vue&type=template&id=1e2dd054&scoped=true"
import script from "./createBulkPromotion.vue?vue&type=script&lang=js"
export * from "./createBulkPromotion.vue?vue&type=script&lang=js"
import style0 from "./createBulkPromotion.vue?vue&type=style&index=0&id=1e2dd054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2dd054",
  null
  
)

export default component.exports